import {http} from '@/http/index.js';

async function deletePost(postId) {
  return http.delete(`girls/posts/${postId}`);
}

export {deletePost};
